import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle } from 'lucide-react';
const keyAreas = ['Quality Assurance in TVET', 'Internationalisation of TVET Curricula', 'Green Transition in TVET', 'Digitalisation of TVET'];
const benefits = ['Context-sensitive and practical solutions', 'Sustainable and impact-oriented interventions', 'International alignment and best practices', 'Capacity building at all levels', 'Labour-market relevance and responsiveness', 'Support for green and digital transitions'];
export function ImpactSection() {
  return <section className="py-16 bg-slate-50 page-break-inside-avoid" data-id="element-80">
      <div className="container mx-auto px-8" data-id="element-81">
        <div className="text-center mb-12" data-id="element-82">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-3" data-id="element-83">
            Why Choose LBAS
          </h2>
          <h3 className="text-4xl font-bold text-navy mb-6 font-serif" data-id="element-84">
            Comprehensive TVET Expertise
          </h3>
          <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-85">
            Our integrated approach addresses the full spectrum of TVET
            modernisation needs, from quality assurance to digital
            transformation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-86">
          <div className="bg-white p-8 border-l-4 border-navy page-break-inside-avoid" data-id="element-87">
            <h4 className="text-2xl font-bold text-navy mb-6 font-serif" data-id="element-88">
              Our Core TVET Services
            </h4>
            <div className="space-y-4" data-id="element-89">
              {keyAreas.map((area, idx) => <div key={idx} className="flex items-start" data-id="element-90">
                  <CheckCircle className="w-5 h-5 text-gold mr-3 mt-0.5 flex-shrink-0" data-id="element-91" />
                  <span className="text-gray-700 font-medium" data-id="element-92">{area}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-white p-8 border-l-4 border-gold page-break-inside-avoid" data-id="element-93">
            <h4 className="text-2xl font-bold text-navy mb-6 font-serif" data-id="element-94">
              What Sets Us Apart
            </h4>
            <div className="space-y-4" data-id="element-95">
              {benefits.map((benefit, idx) => <div key={idx} className="flex items-start" data-id="element-96">
                  <CheckCircle className="w-5 h-5 text-gold mr-3 mt-0.5 flex-shrink-0" data-id="element-97" />
                  <span className="text-gray-700" data-id="element-98">{benefit}</span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="bg-navy text-white p-8 page-break-inside-avoid" data-id="element-99">
          <div className="max-w-3xl mx-auto text-center" data-id="element-100">
            <h4 className="text-2xl font-bold mb-4 font-serif" data-id="element-101">
              Modernising TVET for{' '}
              <span className="text-gold" data-id="element-102">Tomorrow's Workforce</span>
            </h4>
            <p className="text-gray-300 leading-relaxed" data-id="element-103">
              LBAS brings deep expertise in TVET quality assurance,
              internationalisation, green skills, and digitalisation. We work
              collaboratively with institutions, governments, and employers to
              build TVET systems that are fit for purpose, internationally
              recognised, and aligned with labour-market needs and global
              sustainability goals.
            </p>
          </div>
        </div>
      </div>
    </section>;
}